<div class="financeiro-header">
  <div class="header-left">
    <h4 class="page-title">
      <i class="fe-bar-chart-2"></i>
      Financeiro Mesas
    </h4>
    <p class="page-subtitle">Visão geral de comandas e receita</p>
  </div>
</div>

<div class="quick-filters-bar">
  <div class="quick-filters-left">
    <app-periodo-dropdown
      [quickDateFilter]="quickDateFilter"
      [filtroInicio]="filtro.inicio"
      [filtroFim]="filtro.fim"
      (periodoAlterado)="onPeriodoAlterado($event)">
    </app-periodo-dropdown>
  </div>
  <div class="quick-filters-right">
    <button class="btn-filtros" [class.active]="mostrarFiltrosAvancados" (click)="toggleFiltrosAvancados()">
      <i class="fe-settings mr-1"></i> Filtros
      <i class="fe-chevron-up ml-1" *ngIf="mostrarFiltrosAvancados"></i>
      <i class="fe-chevron-down ml-1" *ngIf="!mostrarFiltrosAvancados"></i>
    </button>
  </div>
</div>

<div class="filtros-panel" *ngIf="mostrarFiltrosAvancados">
  <div class="filtro-group" *ngIf="garcons.length">
    <label class="filtro-label">GARÇONS</label>
    <kendo-multiselect [(ngModel)]="filtro.garcons" [data]="garcons"
                       placeholder="Todos" class="filtro-select"
                       textField="nome" valueField="id"
                       (ngModelChange)="carregueResumoVendas()">
    </kendo-multiselect>
  </div>

  <div class="filtro-group">
    <label class="filtro-label">TIPO DE COMANDA</label>
    <div class="filtro-pills">
      <label class="checkbox-pill" [class.checked]="filtro.comanda === 'ambas'">
        <input type="radio" name="comandaV2" [value]="'ambas'" [(ngModel)]="filtro.comanda" (ngModelChange)="carregueResumoVendas()"/>
        <span>Ambas</span>
      </label>
      <label class="checkbox-pill" [class.checked]="filtro.comanda === 'unico'">
        <input type="radio" name="comandaV2" [value]="'unico'" [(ngModel)]="filtro.comanda" (ngModelChange)="carregueResumoVendas()"/>
        <span>Pedido único</span>
      </label>
      <label class="checkbox-pill" [class.checked]="filtro.comanda === 'multiplo'">
        <input type="radio" name="comandaV2" [value]="'multiplo'" [(ngModel)]="filtro.comanda" (ngModelChange)="carregueResumoVendas()"/>
        <span>Múltiplos pedidos</span>
      </label>
    </div>
  </div>

  <div class="filtro-group">
    <label class="filtro-label">FORMA DE PAGAMENTO</label>
    <kendo-multiselect [(ngModel)]="filtro.formasDePagamento" [data]="empresa.formasDePagamento || []"
                       placeholder="Todas" class="filtro-select"
                       textField="descricao" valueField="id"
                       (ngModelChange)="carregueResumoVendas()">
    </kendo-multiselect>
  </div>

  <div class="filtro-group" *ngIf="redes.length">
    <label class="filtro-label">REDE</label>
    <kendo-combobox [(ngModel)]="filtro.rede" [data]="redes"
                    placeholder="Todas" class="filtro-select" [textField]="'nome'"
                    (ngModelChange)="carregueResumoVendas()">
    </kendo-combobox>
  </div>
</div>

<div class="summary-cards-container">
  <div class="summary-card card-blue">
    <div class="card-top">
      <span class="card-label">Total de vendas</span>
      <i class="fe-trending-up card-icon"></i>
    </div>
    <div class="card-value">
      {{(empresa.cobrarTaxaServico ? resumoVendas.totalComTaxa : resumoVendas.total) | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-green">
    <div class="card-top">
      <span class="card-label">Valor líquido</span>
      <i class="fe-check card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.total | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-purple">
    <div class="card-top">
      <span class="card-label">Qtde comandas</span>
      <i class="fe-shopping-bag card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.qtde | number}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-teal">
    <div class="card-top">
      <span class="card-label">Ticket médio</span>
      <i class="fe-bar-chart card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.ticketMedio | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>

  <div class="summary-card card-orange" *ngIf="empresa.cobrarTaxaServico">
    <div class="card-top">
      <span class="card-label">Taxa de serviço</span>
      <i class="fe-percent card-icon"></i>
    </div>
    <div class="card-value">
      {{resumoVendas.totalTaxaServico | currency: "BRL"}}
      <i class="k-icon k-i-loading" *ngIf="carregando"></i>
    </div>
  </div>
</div>

<div class="chart-container" *ngIf="chartLabels.length > 1">
  <div class="card">
    <div class="card-body">
      <div class="chart-header">
        <div>
          <h5 class="chart-title">Evolução de vendas</h5>
          <p class="chart-subtitle">{{obtenhaDescricaoFiltro()}}</p>
        </div>
        <div class="chart-legend">
          <span class="legend-item"><span class="legend-dot legend-blue"></span> Dias úteis</span>
          <span class="legend-item"><span class="legend-dot legend-orange"></span> Fim de semana</span>
        </div>
      </div>

      <kendo-chart [style.height.px]="300">
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item [categories]="chartLabels">
            <kendo-chart-category-axis-item-labels [rotation]="0" [font]="'11px sans-serif'" [color]="'#94a3b8'">
            </kendo-chart-category-axis-item-labels>
          </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>

        <kendo-chart-value-axis>
          <kendo-chart-value-axis-item>
            <kendo-chart-value-axis-item-labels format="c0" [font]="'11px sans-serif'" [color]="'#94a3b8'">
            </kendo-chart-value-axis-item-labels>
          </kendo-chart-value-axis-item>
        </kendo-chart-value-axis>

        <kendo-chart-series>
          <kendo-chart-series-item
            [data]="chartDiasUteis"
            [type]="'column'"
            name="Dias úteis"
            color="#3B82F6"
            [gap]="0.5"
            [spacing]="0">
            <kendo-chart-series-item-tooltip>
              <ng-template let-value="value" let-category="category">
                <div *ngIf="value">{{category}}: {{value | currency: "BRL"}}</div>
              </ng-template>
            </kendo-chart-series-item-tooltip>
          </kendo-chart-series-item>

          <kendo-chart-series-item
            [data]="chartFimSemana"
            [type]="'column'"
            name="Fim de semana"
            color="#F97316"
            [gap]="0.5"
            [spacing]="0">
            <kendo-chart-series-item-tooltip>
              <ng-template let-value="value" let-category="category">
                <div *ngIf="value">{{category}}: {{value | currency: "BRL"}}</div>
              </ng-template>
            </kendo-chart-series-item-tooltip>
          </kendo-chart-series-item>
        </kendo-chart-series>

        <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      </kendo-chart>
    </div>
  </div>
</div>

<div class="card" [hidden]="vendasDoDia">
  <div class="card-body">
    <kendo-tabstrip class="nav-bordered" (tabSelect)="selecionouTab($event)">
      <kendo-tabstrip-tab [title]="'Por loja'" [id]="'loja'" *ngIf="rede" [selected]="abaPrincipalAtiva === 'loja'">
        <ng-template kendoTabContent>
          <h5>Vendas por loja <b>{{obtenhaDescricaoFiltro()}}</b></h5>
          <kendo-grid [data]="vendasLojasResultSet" [loading]="carregando" style="min-height: 300px;"
                      [sortable]="{mode: 'single'}" [sort]="sortLoja" (sortChange)="sortChangeLojas($event)">
            <ng-template kendoGridToolbarTemplate>
              <button type="button" kendoGridExcelCommand icon="file-excel">Exportar</button>
            </ng-template>
            <kendo-grid-column title="Cod. Loja" field="codigoLoja" [width]="150">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-dark">{{resumo.codigoLoja}}</span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Loja" field="nomeLoja">
              <ng-template kendoGridCellTemplate let-resumo><span class="text-dark">{{resumo.nomeLoja}}</span></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde Comandas" field="qtde" [width]="160">
              <ng-template kendoGridCellTemplate let-resumo><b>{{resumo.qtde | number}}</b></ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="totalComTaxa" [width]="220">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-success"><b>{{(resumo.totalComTaxa || resumo.total) | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Ticket médio" field="ticketMedio" [width]="180">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-muted"><b>{{resumo.ticketMedio | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('lojas')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Vendas diárias'" [id]="'vendas'" [selected]="abaPrincipalAtiva === 'vendas'">
        <ng-template kendoTabContent>
          <div class="tab-header">
            <h5>Vendas diárias {{obtenhaDescricaoFiltro()}}</h5>
          </div>
          <kendo-grid [kendoGridBinding]="resumoVendas.diarias" [loading]="carregando" style="min-height: 300px;">
            <kendo-grid-messages
              pagerPage="Página"
              pagerOf="de"
              pagerItems="itens"
              noRecords="nenhuma venda no período"
              loading="Carregando"
              pagerItemsPerPage="itens por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <button type="button" kendoGridExcelCommand icon="file-excel">Exportar</button>
            </ng-template>
            <kendo-grid-column title="Dia" field="dia" [width]="150">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-dark">{{resumoDia.dia}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde comandas" field="qtde" [width]="170">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <b class="text-primary">{{resumoDia.qtde | number}}</b>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="totalComTaxa" [width]="220">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-success"><b>{{(resumoDia.totalComTaxa || resumoDia.total) | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Valor líquido" field="total" [width]="220">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-success"><b>{{resumoDia.total | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Ticket médio" field="ticketMedio" [width]="180">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <span class="text-muted"><b>{{resumoDia.ticketMedio | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="80">
              <ng-template kendoGridCellTemplate let-resumoDia>
                <button class="btn btn-outline-blue btn-sm" (click)="verPedidos(resumoDia)" title="ver pedidos" kendoTooltip>
                  <i class="fe-list fa-lg"></i>
                </button>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-diarias')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Por Produtos'" [id]="'produtos'" [selected]="abaPrincipalAtiva === 'produtos'">
        <ng-template kendoTabContent>
          <h5>
            Produtos vendidos {{obtenhaDescricaoFiltro()}}
            <div class="ml-2 form-group d-inline-block">
              <input type="checkbox" id="porAdicionaisMesasV2" name="porAdicionaisMesasV2" class="k-checkbox" kendoCheckBox
                     [(ngModel)]="filtro.porAdicionais" (ngModelChange)="carregueResumoProdutos()"/>
              <label class="k-checkbox-label" for="porAdicionaisMesasV2">Exibir vendas dos adicionais</label>
            </div>
          </h5>

          <kendo-grid [kendoGridBinding]="resumoProdutos.produtos" [loading]="resumoProdutos.carregando"
                      [groupable]="true" [group]="group" style="min-height: 300px;">
            <kendo-grid-messages
              pagerPage="Página"
              pagerOf="de"
              pagerItems="itens"
              noRecords="nenhum produto vendido no período"
              loading="Carregando"
              pagerItemsPerPage="itens por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <button type="button" kendoGridExcelCommand icon="file-excel">Exportar</button>
            </ng-template>
            <kendo-grid-column title="Código" field="codigo" [width]="110">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <span class="text-blue"><b>{{resumoProduto.codigo}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Produto" field="nome">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <span class="text-dark">{{resumoProduto.nome}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde vendida" field="qtdeDescricao" [width]="230">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <b>{{resumoProduto.qtdeDescricao}}</b>
              </ng-template>
              <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                <span>Qtde vendida: {{aggregates.qtde.sum | number}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="total" [width]="210">
              <ng-template kendoGridCellTemplate let-resumoProduto>
                <span class="text-success"><b>{{resumoProduto.total | currency: "BRL"}}</b></span>
              </ng-template>
              <ng-template kendoGridGroupFooterTemplate let-aggregates="aggregates">
                <ng-container *ngIf="resumoProdutos.totalDescontos">
                  <label>Total produtos: <span class="text-success">+{{aggregates.total.sum | currency: 'BRL'}}</span></label>
                  <label>Total descontos: <span class="text-danger">-{{resumoProdutos.totalDescontos | currency: 'BRL'}}</span></label>
                </ng-container>
                <label>Total: <span class="text-success"><b>{{(aggregates.total.sum - resumoProdutos.totalDescontos) | currency: 'BRL'}}</b></span></label>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload(filtro.porAdicionais ? 'vendas-adicionais' : 'vendas-produtos')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="'Por Garçom'" [id]="'garcons'" [selected]="abaPrincipalAtiva === 'garcons'">
        <ng-template kendoTabContent>
          <h5>Vendas por garçom {{obtenhaDescricaoFiltro()}}</h5>
          <kendo-grid [kendoGridBinding]="resumoGarcons.garcons" [loading]="resumoGarcons.carregando" style="min-height: 300px;">
            <kendo-grid-messages
              pagerPage="Página"
              pagerOf="de"
              pagerItems="itens"
              noRecords="nenhuma venda no período"
              loading="Carregando"
              pagerItemsPerPage="itens por página">
            </kendo-grid-messages>
            <ng-template kendoGridToolbarTemplate>
              <button type="button" kendoGridExcelCommand icon="file-excel">Exportar</button>
            </ng-template>
            <kendo-grid-column title="Código" field="codigo" [width]="120">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-blue"><b>{{resumo.codigo}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Garçom" field="garcom">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-dark"><b>{{resumo.garcom}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Qtde comandas" field="qtde" [width]="170">
              <ng-template kendoGridCellTemplate let-resumo>
                <b>{{resumo.qtde | number}}</b>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Total vendido" field="total" [width]="210">
              <ng-template kendoGridCellTemplate let-resumo>
                <span class="text-success"><b>{{resumo.total | currency: "BRL"}}</b></span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="obtenhaNomeArquivoDownload('vendas-garcons')"></kendo-grid-excel>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </div>
</div>

<ng-container *ngIf="vendasDoDia">
  <h4>
    <button class="btn btn-outline-blue btn-rounded" (click)="voltarVendasDia()">
      <i class="fa fa-arrow-left ct-point"></i>
    </button>
    Vendas do dia <span><b>{{vendasDoDia.dia}}</b></span>
  </h4>

  <app-grid-pedidos
    #gridPedidos
    [pedidos]="vendasDoDia.pedidos"
    [carregando]="vendasDoDia.carregando"
    [mesa]="true">
  </app-grid-pedidos>
</ng-container>
